<template>
    <LFeatureGroup>
        <LCircle
            v-if="latLng"
            ref="circle"
            :lat-lng="latLng"
            :radius="radius"
        />
    </LFeatureGroup>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { LFeatureGroup, LCircle } from 'vue2-leaflet'
import { debounce } from 'lodash'
import L from 'leaflet'

export default {
    name: 'RadialSearchLayer',
    components: {
        LFeatureGroup,
        LCircle,
    },
    computed: {
        ...mapState('axroad', [
            'radialSearchCenter',
            'radialSearchRadius',
            'radialSearchMode',
        ]),
        ...mapGetters('axroad', ['radialSearchPolygon']),
        latLng() {
            return this.radialSearchCenter
                ? [this.radialSearchCenter.lat, this.radialSearchCenter.lng]
                : null
        },
        radius() {
            return this.radialSearchRadius || 100
        },
    },
    watch: {
        latLng: 'fitCircleBounds',
        radius: 'fitCircleBounds',
    },
    methods: {
        fitCircleBounds: debounce(function() {
            if (this.latLng && this.radius) {
                const bounds = L.latLng(this.latLng).toBounds(this.radius * 2)
                this.$emit('alignMap', [
                    bounds.getNorthWest(),
                    bounds.getSouthEast(),
                ])
            }
        }, 100),
    },
}
</script>
